'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect, useRef } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
export interface SectionItem {
  id: number;
  name: string;
}
export interface FilterData {
  sections: SectionItem[];
  authors: string[];
  storyTypes: string[];
}
interface SearchFilterProps {
  filterData?: FilterData;
  onFilterChange?: (filters: Record<string, string[] | number[] | {
    from: string;
    to: string;
  }>) => void;
}
export default function SearchFilter(t0) {
  const $ = _c(94);
  const {
    filterData,
    onFilterChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      Section: true,
      Author: false,
      "Story Type": false,
      Date: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [expandedSections, setExpandedSections] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [selectedFilters, setSelectedFilters] = useState(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [selectedSectionNames, setSelectedSectionNames] = useState(t3);
  const [showMoreSection, setShowMoreSection] = useState(false);
  const [showMoreAuthor, setShowMoreAuthor] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const isInitialMount = useRef(true);
  let t4;
  let t5;
  if ($[3] !== dateFrom || $[4] !== dateTo || $[5] !== onFilterChange || $[6] !== selectedFilters || $[7] !== selectedSectionNames) {
    t4 = () => {
      if (isInitialMount.current) {
        isInitialMount.current = false;
        return;
      }
      if (onFilterChange) {
        onFilterChange({
          ...selectedFilters,
          "Section-Name": selectedSectionNames,
          Date: {
            from: dateFrom,
            to: dateTo
          }
        });
      }
    };
    t5 = [selectedFilters, selectedSectionNames, dateFrom, dateTo, onFilterChange];
    $[3] = dateFrom;
    $[4] = dateTo;
    $[5] = onFilterChange;
    $[6] = selectedFilters;
    $[7] = selectedSectionNames;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = title => {
      setExpandedSections(prev => {
        const isCurrentlyOpen = prev[title];
        return {
          Section: false,
          Author: false,
          "Story Type": false,
          Date: false,
          [title]: !isCurrentlyOpen
        };
      });
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const toggleSection = t6;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = (section, option) => {
      setSelectedFilters(prev_0 => {
        const currentSelections = prev_0[section] || [];
        const newSelections = currentSelections.includes(option) ? currentSelections.filter(item => item !== option) : [...currentSelections, option];
        return {
          ...prev_0,
          [section]: newSelections
        };
      });
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const handleCheckboxChange = t7;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = sectionItem => {
      setSelectedSectionNames(prev_1 => {
        const newNames = prev_1.includes(sectionItem.name) ? prev_1.filter(name => name !== sectionItem.name) : [...prev_1, sectionItem.name];
        return newNames;
      });
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const handleSectionCheckboxChange = t8;
  let t9;
  if ($[13] !== selectedSectionNames) {
    t9 = sectionName => selectedSectionNames.includes(sectionName);
    $[13] = selectedSectionNames;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const isSectionChecked = t9;
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = (type, value) => {
      if (type === "from") {
        setDateFrom(value);
      } else {
        setDateTo(value);
      }
    };
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const handleDateChange = t10;
  let t11;
  if ($[16] !== selectedFilters) {
    t11 = (section_0, option_0) => selectedFilters[section_0]?.includes(option_0) || false;
    $[16] = selectedFilters;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const isChecked = t11;
  let authorsData;
  let storyTypesData;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  if ($[18] !== expandedSections.Author || $[19] !== expandedSections.Section || $[20] !== filterData?.authors || $[21] !== filterData?.sections || $[22] !== filterData?.storyTypes || $[23] !== isChecked || $[24] !== isSectionChecked || $[25] !== showMoreAuthor || $[26] !== showMoreSection) {
    const sectionsData = filterData?.sections || [];
    authorsData = filterData?.authors || [];
    let t18;
    if ($[35] !== filterData?.storyTypes) {
      t18 = filterData?.storyTypes || [];
      $[35] = filterData?.storyTypes;
      $[36] = t18;
    } else {
      t18 = $[36];
    }
    storyTypesData = t18;
    t15 = "bg-white p-4";
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <h2 className="text-[#012061] text-lg font-semibold mb-4">Filter</h2>;
      $[37] = t16;
    } else {
      t16 = $[37];
    }
    let t19;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = () => toggleSection("Section");
      $[38] = t19;
    } else {
      t19 = $[38];
    }
    let t20;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <span className="text-[#012061] font-medium">Section</span>;
      $[39] = t20;
    } else {
      t20 = $[39];
    }
    let t21;
    if ($[40] !== expandedSections.Section) {
      t21 = <button onClick={t19} className="w-full flex items-center justify-between py-3 text-left">{t20}{expandedSections.Section ? <ChevronUp className="text-gray-500" size={20} /> : <ChevronDown className="text-gray-500" size={20} />}</button>;
      $[40] = expandedSections.Section;
      $[41] = t21;
    } else {
      t21 = $[41];
    }
    const t22 = expandedSections.Section && sectionsData.length > 0 && <div className="pb-3">{sectionsData.slice(0, showMoreSection ? sectionsData.length : 7).map(sectionItem_0 => <label key={sectionItem_0.id} className="flex items-center gap-3 py-2 cursor-pointer hover:bg-gray-50 px-2 rounded"><input type="checkbox" checked={isSectionChecked(sectionItem_0.name)} onChange={() => handleSectionCheckboxChange(sectionItem_0)} className="w-4 h-4 border-gray-300 rounded text-[#012061] focus:ring-[#012061]" /><span className="text-gray-700">{sectionItem_0.name}</span></label>)}{sectionsData.length > 7 && <button onClick={() => setShowMoreSection(!showMoreSection)} className="text-[#012061] text-sm mt-2 hover:underline">{showMoreSection ? "Show Less" : `${sectionsData.length - 7} More`}</button>}</div>;
    let t23;
    if ($[42] !== expandedSections.Section || $[43] !== sectionsData) {
      t23 = expandedSections.Section && sectionsData.length === 0 && <div className="pb-3 px-2 text-gray-500 text-sm">No options available</div>;
      $[42] = expandedSections.Section;
      $[43] = sectionsData;
      $[44] = t23;
    } else {
      t23 = $[44];
    }
    if ($[45] !== t21 || $[46] !== t22 || $[47] !== t23) {
      t17 = <div className="border-b border-gray-200">{t21}{t22}{t23}</div>;
      $[45] = t21;
      $[46] = t22;
      $[47] = t23;
      $[48] = t17;
    } else {
      t17 = $[48];
    }
    t12 = "border-b border-gray-200";
    let t24;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
      t24 = () => toggleSection("Author");
      $[49] = t24;
    } else {
      t24 = $[49];
    }
    let t25;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = <span className="text-[#012061] font-medium">Author</span>;
      $[50] = t25;
    } else {
      t25 = $[50];
    }
    if ($[51] !== expandedSections.Author) {
      t13 = <button onClick={t24} className="w-full flex items-center justify-between py-3 text-left">{t25}{expandedSections.Author ? <ChevronUp className="text-gray-500" size={20} /> : <ChevronDown className="text-gray-500" size={20} />}</button>;
      $[51] = expandedSections.Author;
      $[52] = t13;
    } else {
      t13 = $[52];
    }
    t14 = expandedSections.Author && authorsData.length > 0 && <div className="pb-3">{authorsData.slice(0, showMoreAuthor ? authorsData.length : 7).map(author => <label key={author} className="flex items-center gap-3 py-2 cursor-pointer hover:bg-gray-50 px-2 rounded"><input type="checkbox" checked={isChecked("Author", author)} onChange={() => handleCheckboxChange("Author", author)} className="w-4 h-4 border-gray-300 rounded text-[#012061] focus:ring-[#012061]" /><span className="text-gray-700">{author}</span></label>)}{authorsData.length > 7 && <button onClick={() => setShowMoreAuthor(!showMoreAuthor)} className="text-[#012061] text-sm mt-2 hover:underline">{showMoreAuthor ? "Show Less" : `${authorsData.length - 7} More`}</button>}</div>;
    $[18] = expandedSections.Author;
    $[19] = expandedSections.Section;
    $[20] = filterData?.authors;
    $[21] = filterData?.sections;
    $[22] = filterData?.storyTypes;
    $[23] = isChecked;
    $[24] = isSectionChecked;
    $[25] = showMoreAuthor;
    $[26] = showMoreSection;
    $[27] = authorsData;
    $[28] = storyTypesData;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
  } else {
    authorsData = $[27];
    storyTypesData = $[28];
    t12 = $[29];
    t13 = $[30];
    t14 = $[31];
    t15 = $[32];
    t16 = $[33];
    t17 = $[34];
  }
  let t18;
  if ($[53] !== authorsData || $[54] !== expandedSections.Author) {
    t18 = expandedSections.Author && authorsData.length === 0 && <div className="pb-3 px-2 text-gray-500 text-sm">No options available</div>;
    $[53] = authorsData;
    $[54] = expandedSections.Author;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] !== t12 || $[57] !== t13 || $[58] !== t14 || $[59] !== t18) {
    t19 = <div className={t12}>{t13}{t14}{t18}</div>;
    $[56] = t12;
    $[57] = t13;
    $[58] = t14;
    $[59] = t18;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  let t20;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = () => toggleSection("Story Type");
    $[61] = t20;
  } else {
    t20 = $[61];
  }
  let t21;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="text-[#012061] font-medium">Story Type</span>;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  let t22;
  if ($[63] !== expandedSections) {
    t22 = <button onClick={t20} className="w-full flex items-center justify-between py-3 text-left">{t21}{expandedSections["Story Type"] ? <ChevronUp className="text-gray-500" size={20} /> : <ChevronDown className="text-gray-500" size={20} />}</button>;
    $[63] = expandedSections;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  let t23;
  if ($[65] !== expandedSections || $[66] !== isChecked || $[67] !== storyTypesData) {
    t23 = expandedSections["Story Type"] && storyTypesData.length > 0 && <div className="pb-3">{storyTypesData.map(storyType => <label key={storyType} className="flex items-center gap-3 py-2 cursor-pointer hover:bg-gray-50 px-2 rounded"><input type="checkbox" checked={isChecked("Story Type", storyType)} onChange={() => handleCheckboxChange("Story Type", storyType)} className="w-4 h-4 border-gray-300 rounded text-[#012061] focus:ring-[#012061]" /><span className="text-gray-700">{storyType}</span></label>)}</div>;
    $[65] = expandedSections;
    $[66] = isChecked;
    $[67] = storyTypesData;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  let t24;
  if ($[69] !== expandedSections || $[70] !== storyTypesData) {
    t24 = expandedSections["Story Type"] && storyTypesData.length === 0 && <div className="pb-3 px-2 text-gray-500 text-sm">No options available</div>;
    $[69] = expandedSections;
    $[70] = storyTypesData;
    $[71] = t24;
  } else {
    t24 = $[71];
  }
  let t25;
  if ($[72] !== t22 || $[73] !== t23 || $[74] !== t24) {
    t25 = <div className="border-b border-gray-200">{t22}{t23}{t24}</div>;
    $[72] = t22;
    $[73] = t23;
    $[74] = t24;
    $[75] = t25;
  } else {
    t25 = $[75];
  }
  let t26;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => toggleSection("Date");
    $[76] = t26;
  } else {
    t26 = $[76];
  }
  let t27;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <span className="text-[#012061] font-medium">Date</span>;
    $[77] = t27;
  } else {
    t27 = $[77];
  }
  let t28;
  if ($[78] !== expandedSections.Date) {
    t28 = <button onClick={t26} className="w-full flex items-center justify-between py-3 text-left">{t27}{expandedSections.Date ? <ChevronUp className="text-gray-500" size={20} /> : <ChevronDown className="text-gray-500" size={20} />}</button>;
    $[78] = expandedSections.Date;
    $[79] = t28;
  } else {
    t28 = $[79];
  }
  let t29;
  if ($[80] !== dateFrom || $[81] !== dateTo || $[82] !== expandedSections.Date) {
    t29 = expandedSections.Date && <div className="pb-4 px-2"><div className="flex flex-col gap-3"><div><label className="block text-sm text-gray-600 mb-1">From</label><input type="date" value={dateFrom} onChange={e => handleDateChange("from", e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#012061] focus:border-transparent" /></div><div><label className="block text-sm text-gray-600 mb-1">To</label><input type="date" value={dateTo} onChange={e_0 => handleDateChange("to", e_0.target.value)} min={dateFrom} className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#012061] focus:border-transparent" /></div></div></div>;
    $[80] = dateFrom;
    $[81] = dateTo;
    $[82] = expandedSections.Date;
    $[83] = t29;
  } else {
    t29 = $[83];
  }
  let t30;
  if ($[84] !== t28 || $[85] !== t29) {
    t30 = <div className="border-b border-gray-200">{t28}{t29}</div>;
    $[84] = t28;
    $[85] = t29;
    $[86] = t30;
  } else {
    t30 = $[86];
  }
  let t31;
  if ($[87] !== t15 || $[88] !== t16 || $[89] !== t17 || $[90] !== t19 || $[91] !== t25 || $[92] !== t30) {
    t31 = <div className={t15}>{t16}{t17}{t19}{t25}{t30}</div>;
    $[87] = t15;
    $[88] = t16;
    $[89] = t17;
    $[90] = t19;
    $[91] = t25;
    $[92] = t30;
    $[93] = t31;
  } else {
    t31 = $[93];
  }
  return t31;
}